import { Page } from "@/models/page-models/Page";

export const SupplierEdit: Page = {
  "path": "suppliers/:supplierId",
  "name": "Edit Supplier",
  "props": {
    "data": {
      "title": "Edit Supplier",
      "printable": "FALSE",
      "url": "suppliers/:supplierId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.supplier.name",
                  "label": "Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "mapautocomplete",
                  "variable": "formData.supplier.address",
                  "label": "Address",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.supplier.VATNumber",
                  "label": "VAT #",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.supplier.landline",
                  "label": "Landline",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.supplier.isInternational",
                  "label": "International Supplier",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.groups",
                  "label": "Select Groups",
                  "disabled": "FALSE",
                  "items": "fetchedData.supplierGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Supplier Info"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.supplier.contacts",
          "label": "Supplier Contact Details",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "name",
                  "label": "Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "email",
                  "label": "Email",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "mobile",
                  "label": "Mobile",
                  "disabled": "FALSE"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.agent.name",
                  "label": "Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "mapautocomplete",
                  "variable": "formData.agent.address",
                  "label": "Address",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.agent.landline",
                  "label": "Landline",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "{{formData.agent}}",
          "disabled": "TRUE",
          "label": "Agent Info"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.agent.contacts",
          "label": "Agent Contact Details",
          "disabled": "TRUE",
          "showIf": "{{formData.agent}}",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "name",
                  "label": "Name",
                  "disabled": "FALSE",
                  "showIf": "{{formData.agent}}"
                },
                {
                  "type": "input",
                  "variable": "email",
                  "label": "Email",
                  "disabled": "FALSE",
                  "showIf": "{{formData.agent}}"
                },
                {
                  "type": "input",
                  "variable": "mobile",
                  "label": "Mobile",
                  "disabled": "FALSE",
                  "showIf": "{{formData.agent}}"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.currency",
                  "label": "Currency Code",
                  "disabled": "FALSE",
                  "items": "[\"EUR\",\"USD\",\"SAR\",\"AED\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.deliveryTerms",
                  "label": "Trade Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "formula": "{{__item.en}} ({{__item.type}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.paymentTerms",
                  "label": "Payment Terms",
                  "disabled": "FALSE",
                  "items": "[\"CAD (Cash Against Documents)\",\"DFT30 (Draft 30 days from B/L Date)\",\"DFT60 (Draft 60 days from B/L Date)\",\"DFT90 (Draft 90 days from B/L Date)\",\"DFT120 (Draft 120 days from B/L Date)\",\"LC SGHT (ICLC Payable at Sight)\",\"LC30 (ICLC 30 days from B/L Date)\",\"LC45 (ICLC 45 days from B/L Date)\",\"LC60 (ICLC 60 days from B/L Date)\",\"LC90 (ICLC 90 days from B/L Date)\",\"LC120 (ICLC 120 days from B/L Date)\",\"TLX ADV (Advance Telex Transfer)\",\"TLX (Telex Transfer Upon Receipt)\",\"CHQ30 (Cheque 30 days on Goods Receipt)\",\"CHQ45 (Cheque 45 days on Goods Receipt)\",\"CHQ60 (Cheque 60 days on Goods Receipt)\",\"Cash\",\"FOC\",\"CHQ 75 Days from Date of Shipping\",\"CHQ 90 Days from Date of Shipping\",\"On Account\",\"TLX Transfer 120 Days from BL/TWB DATE\",\"TLX Transfer 90 Days from BL/TWB DATE\",\"TLX Transfer 60 Days from BL/TWB DATE\",\"TLX Transfer 30 Days from B/L DATE\",\"Cash in Advance Prior to Shipment By ...\",\"Advance 30% and CAD 70%\",\"Avalised Draft 90 days from BL/TWB Date\",\"Avalised Draft 60 days from B/L Date\",\"CAD 30 days with 2% discount on Invoice\",\"CAD 60 days from B/L Date\",\"CAD 75 days from B/L Date\",\"CAD 90 days from B/L Date\",\"CAD 120 days from B/L Date\",\"CAD 60 days from Invoice Date\",\"CAD 90 days from Invoice Date\",\"CAD 120 days from Invoice Date\",\"Telex Transfer - 50% Advance & 50% Before ...\",\"CAD 60 days\",\"CAD 90 days\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.packingMode",
                  "label": "Packing Mode",
                  "disabled": "FALSE",
                  "items": "[\"Wrapped Rolls for Sea Worthy Shipment\",\"In brand new Steel Drums on Pallet ...\",\"In Rolls, Wrapped and Protected\",\"In Carton Box on Pallets Wrapped\",\"In Rolls, Wrapped and Protected with ...\",\"Wrapped Board For Seaworthy Shipment\",\"Usual Packing\",\"Carton Box\",\"In Rolls, Protected with Strong\",\"None\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.shippingMarks",
                  "label": "Shipping Marks",
                  "disabled": "FALSE",
                  "items": "[\"Made In Germany\",\"Made In Brazil\",\"Made In Canada\",\"Made In India\",\"Made In Denmark\",\"Made In Belgium\",\"Made In U.S.A\",\"Made In China\",\"Made In Indonesia\",\"Made In Korea\",\"Made In K.S.A\",\"Made In Qatar\",\"Made in Sweden\",\"Made in France\",\"Made in Turkey\",\"Made in Spain\",\"Made in UAE\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.shippingMode",
                  "label": "Shipping Mode",
                  "disabled": "FALSE",
                  "items": "[\"Ocean Vessel 20FT Container\",\"Ocean Vessel 40FT Container\",\"Ocean Vessel Break Bulk(Pallets)/ Tons ( LCL Shipment)\",\"Groupage Container Ocean Vessel\",\"Air Freight\",\"Air Post Parcel\",\"Van\",\"DHL Courier Service\",\"Purchaser\",\"Sea Freight\",\"Supplier\",\"Truck\",\"Road Tanker\",\"Ocean Vessel 20FT ISO Tanker\",\"None\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.supplier.termsAndConditions.destinationPort",
                  "label": "Destination Port",
                  "disabled": "FALSE",
                  "items": "[\"Dammam\",\"Jeddah\"]",
                  "dropdownType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Supplier Shipping Info"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "updateSupplier",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/suppliers/{{formData.supplier._id}}/edit",
                        "arg2Key": "postData",
                        "arg2Value": "formData.supplier",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "redirectUrl",
                        "arg4Value": "/suppliers"
                      },
                      "name": "updateSupplier"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getSupplierGroups",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/supplier-groups",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierGroups"
        },
        "name": "getSupplierGroups"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getSupplierDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers/{{__params.supplierId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierData"
        },
        "name": "getSupplierDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copySupplierData",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.supplierData.data",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.supplier"
        },
        "name": "copySupplierData"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getAgentDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/agents/get?supplier={{__params.supplierId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.agentData"
        },
        "name": "getAgentDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyAgentData",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.agentData.data.0",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.agent"
        },
        "name": "copyAgentData"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      }
    ]
  },
  "forRole": "COMMERCIAL_MANAGER",
  "visible": false
}